/**
 * @module store/marathons/mutations
 *
 * @version 1.0.2
 * @copyright SBC 2019
 */


import * as types from '@/store/mutation-types';

/* eslint-disable no-param-reassign */
export default {
  /**
   * Mutation: Начало загрузки страницы со стартами
   *
   * @since Version 1.0.2
   */
  [types.GET_MARATHONS_ASYNC.PENDING](state) {
    state.isLoading = true;
  },


  /**
   * Mutation: Ошибка при загрузке старницы со стартами
   *
   * @since Version 1.0.2
   */
  [types.GET_MARATHONS_ASYNC.FAILURE](state) {
    state.isLoading = false;
  },


  /**
   * Mutation: Успешная загрзка страницы со стартами
   *
   * @since Version 1.0.2
   */
  [types.GET_MARATHONS_ASYNC.SUCCESS](state, { data, total }) {
    state.marathons = data;
    state.total = total;
    state.isLoading = false;
  },
};
/* eslint-enable no-param-reassign */
